<template>
  <div class="flex flex-col min-w-70 h-full safezone-y">
    <V2OrganismNavBar v-bind="navProps" />

    <div
      class="flex-1"
      :class="layoutsStore.getLayoutBg"
    >
      <slot />
    </div>

    <V2OrganismFooter v-if="layoutsStore.footer.show" />
  </div>
</template>

<script setup>
const layoutsStore = useLayoutsStore()

const navProps = layoutsStore.navigation

defineOptions({
  name: 'LayoutsDefault'
})

useOneTap()
</script>
